import { createSelector } from "@reduxjs/toolkit";

import { StoreState } from "~/redux/reducers";

import {
  selectPortStatusesByPortKeyMap,
  selectHandRaisedByIdMap,
  selectPortBinsByPortKeyMap,
  selectGridModeByIdMap
} from "./andon.slice";
import type { AndonStatus, PongData } from "./andon.types";
import { getAndonPortEntry } from "./andon.utils";

const EMPTY_ARRAY: number[] = [];

export const selectPortStatus =
  (portId: string, gridId?: string) =>
  (state: StoreState): AndonStatus =>
    getAndonPortEntry(selectPortStatusesByPortKeyMap(state), portId, gridId) ??
    "good";

export const selectPortHasBins =
  (portId: string, gridId?: string) =>
  (state: StoreState): number[] =>
    getAndonPortEntry(selectPortBinsByPortKeyMap(state), portId, gridId) ??
    EMPTY_ARRAY;

export const selectGridSystemMode = (gridId: string) =>
  createSelector(
    (state: StoreState) => selectGridModeByIdMap(state),
    (modes) => modes[gridId] ?? null
  );

export const selectPongLoopHistory =
  (workstationId: string) =>
  (
    state: StoreState
  ): { pongData: PongData; loopTime: number; timestamp: string }[] =>
    state.andon.workstationPongHistory[workstationId] ?? [];

export const selectEventHistory = (state: StoreState) =>
  state.andon.eventHistory;

export const selectLayoutCode = createSelector(
  (state: StoreState) => state.andon.boardLayout,
  (state: StoreState) => state.andon.boardDimensions,
  (layout, dimensions) =>
    JSON.stringify({
      layout,
      dimensions
    })
);

export const selectHandRaiseStartTime = (id: string) => (state: StoreState) =>
  state.andon.handRaisedByWorkstationId[id]?.timestamp ?? null;

export const selectHandRaisedForWorkstation = (workstationId?: string) =>
  createSelector(selectHandRaisedByIdMap, (map) =>
    workstationId && map[workstationId]
      ? map[workstationId]
      : { raised: false, timestamp: null, requestType: null }
  );
